module.exports = __webpack_public_path__ + "zvetseni-prsou_15_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_15_before.jpg
// module id = 1304
// module chunks = 0